import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function PlayIcon({ fill = '#0851DF', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      className={className}
      aria-hidden={ariaHidden}
    >
      <path
        d="M9.77336 7.59123L3.05599 11.7019C1.71932 12.5199 0 11.5605 0 9.99651V2.00383C0 0.439832 1.71932 -0.519409 3.05599 0.298591L9.77336 4.40927C10.9634 5.13793 10.9634 6.86323 9.77336 7.59123Z"
        fill={fill}
      />
    </svg>
  );
}

export default PlayIcon;
